

import lazyWithRetry from '@/utils/lazyWithRetry';
// Lazy load pages
const Login = lazyWithRetry(() => import('@pages/Login'));
const Otp = lazyWithRetry(() => import('@pages/Otp'));
const Dashboard = lazyWithRetry(() => import('@pages/Dashboard/index.jsx'));
const Homepage = lazyWithRetry(() => import('@pages/homepage'));
const DetailPage = lazyWithRetry(() => import('@/pages/Search/Detailpage'));
const SearchPage = lazyWithRetry(() => import('@/pages/Search'));
const AboutPage = lazyWithRetry(() => import('@pages/about'));
const ContactPage = lazyWithRetry(() => import('@/pages/contact'));
const ProductPage = lazyWithRetry(() => import('@/pages/Search/product'));
const Role = lazyWithRetry(() => import('@/pages/onboarding/Role'));
const Messages = lazyWithRetry(() => import('@/pages/Messages'));
const Explore = lazyWithRetry(() => import('@/pages/Explore'))
const Requirement = lazyWithRetry(() => import('@/pages/Requirement'));
const Products = lazyWithRetry(() => import('@/pages/products'));
const AddEditProduct = lazyWithRetry(() => import('@/pages/products/add-edit'));
const Profile = lazyWithRetry(() => import('@/pages/profile'));
const MyProfile = lazyWithRetry(() => import('@/pages/Myprofile'));
const SavedProfile = lazyWithRetry(() => import('@/pages/SavedProfiles'));
const NotFound = lazyWithRetry(() => import('@/pages/404'))
const TallyDashboard = lazyWithRetry(() => import('@/pages/tallyReports/index'));
const FinancialDashboard = lazyWithRetry(() => import('@/pages/tallyReports/NewDashboardv2'));
const MfgDashboard = lazyWithRetry(() => import('@/pages/mfgDashboard/MfgDashboard'));
const TransactionSales = lazyWithRetry(() => import('@/pages/transactions/sales'));
const TransactionPurchase = lazyWithRetry(() => import('@/pages/transactions/purchase'));
const TransactionPayment = lazyWithRetry(() => import('@/pages/transactions/payment'));
const TransactionReceipt = lazyWithRetry(() => import('@/pages/transactions/receipt'));
const SendRequest = lazyWithRetry(() => import('@/pages/secondarySales/sendRequest'));
const SendRequestV2 = lazyWithRetry(() => import('@/pages/secondarySales/sendRequest/sendRequstv2'));
const AutoMapSkus = lazyWithRetry(() => import('@/pages/secondarySales/autoMapSkus/AutoMapSkus'));
const MyRequests = lazyWithRetry(() => import('@/pages/secondarySales/myRequests'));
const MyRequestsV2 = lazyWithRetry(() => import('@/pages/secondarySales/myRequests/myRequestv2'));
const DistributorNetwork = lazyWithRetry(() => import('@/pages/secondarySales/DistributorNetwork/DistributorNetwork'));
const MyRequestDetail = lazyWithRetry(() => import('@/pages/secondarySales/myRequests/requestDetail'));
const MyRequestDetail2 = lazyWithRetry(() => import('@/pages/secondarySales/myRequests/Requestdetail2/requestdetail2'));
const Requests = lazyWithRetry(() => import('@/pages/secondarySales/requests'));
const RequestsV2 = lazyWithRetry(() => import('@/pages/secondarySales/requests/request2/request2'));
const RequestMap = lazyWithRetry(() => import('@/pages/secondarySales/requestMap'));
const RequestMapV2 = lazyWithRetry(() => import('@/pages/secondarySales/requestMap/requestMapv2'));
const HierarchyMappingPage = lazyWithRetry(() => import('@/pages/secondarySales/hierarchyMapping'));
const MappingLogs = lazyWithRetry(() => import('@/pages/mappinglogs'));
const MappingLogsV2 = lazyWithRetry(() => import('@/pages/mappinglogs/mappinglogsv2'));
const SalesInvoices = lazyWithRetry(() => import('@/pages/sales/invoices'));
const SalesInvoiceDetail = lazyWithRetry(() => import('@/pages/sales/invoices/detail'));
const SalesDistributors = lazyWithRetry(() => import('@/pages/sales/distributors2'));
const SalesDistributorsV2 = lazyWithRetry(() => import('@/pages/sales/distributorsV2'));
const SalesOutlets = lazyWithRetry(() => import('@/pages/sales/outlets'));
const SalesOutlets2 = lazyWithRetry(() => import('@/pages/sales/outlets2'));
const SalesInvoices2 = lazyWithRetry(() => import('@/pages/sales/invoices2'));
const SalesInvoiceDetail2 = lazyWithRetry(() => import('@/pages/sales/invoices2/invoiceDetail2'));
const SkuSales = lazyWithRetry(() => import('@/pages/manufacturers/sku-sales'));
const SkuSalesV2 = lazyWithRetry(() => import('@/pages/sku-sales(V2)'));
const SKUMappingDetails = lazyWithRetry(() => import('@/pages/sku-sales(V2)/sku-mapping-details'));
const MappedDistributors = lazyWithRetry(() => import('@/pages/manufacturers/sku-sales/mapped-distributors'));
const MappedDistributorsV2 = lazyWithRetry(() => import('@/pages/sku-sales(V2)/mapped-distributorsV2/MappedDistributorv2'));
const UnmappedSkus = lazyWithRetry(() => import('@/pages/manufacturers/sku-sales/unmapped-skus'));
const Manufacturers = lazyWithRetry(() => import('@/pages/manufacturers/index.jsx'));
const MasterSkus = lazyWithRetry(() => import('@/pages/skus/index'));
const MasterSkus2 = lazyWithRetry(() => import('@/pages/skus/sku2/sku2'));
const Invoices = lazyWithRetry(() => import('@/pages/invoices'));
const InvoiceDetail = lazyWithRetry(() => import('@/pages/invoices/detail'));
const UserRoleManagement = lazyWithRetry(() => import('@/pages/UserRoleManagement'));
const RolesAndPermissions = lazyWithRetry(() => import('@/pages/UserRoleManagement').then(module => ({ default: module.RolesAndPermissions })));
const CreateRole = lazyWithRetry(() => import('@/pages/UserRoleManagement').then(module => ({ default: module.CreateRole })));
const Receivable = lazyWithRetry(() => import('@/pages/Receivable'));
const ReceivableDetailPage = lazyWithRetry(() => import('@/pages/Receivable/ReceivableDetailPage'));
const ReceivablesV2 = lazyWithRetry(() => import('@/pages/ReceivablesV2'));
const CustomerDetailPageV2 = lazyWithRetry(() => import('@/pages/ReceivablesV2/CustomerDetailPagev2/CustomerDetailPage'));
const Payable = lazyWithRetry(() => import('@/pages/Payable'));
const PayableDetailPage = lazyWithRetry(() => import('@/pages/Payable/PayableDetailPage'));
const PayablesV2 = lazyWithRetry(() => import('@/pages/Payablesv2'));
const SupplierDetailPageV2 = lazyWithRetry(() => import('@/pages/Payablesv2/SupplierDetailPageV2'));
const Labels = lazyWithRetry(() => import('@/pages/labels'));
const TeamMembersPage = lazyWithRetry(() => import('@/pages/labels/TeamMembersPage'));
const PrivacyPolicy = lazyWithRetry(() => import('@/pages/PrivacyPolicy'));
const TallySync = lazyWithRetry(() => import('@/pages/tallyReports/advanced'));
const IndustryCategories = lazyWithRetry(() => import('@/pages/industryCategories'));
const SalesMapping = lazyWithRetry(() => import('@/pages/SalesTeamMapping/SalesMapping'));
const DistributorStaffMapping = lazyWithRetry(() => import('@/pages/SalesTeamMapping/DistributorStaffMapping'));
const IndustrySubcategories = lazyWithRetry(() => import('@pages/industrySubcategories/index'))
const SubcategoryDetail = lazyWithRetry(() => import('@pages/industrySubcategories/SubcategoryDetail'))
const SalesPersonProfile = lazyWithRetry(() => import('@/pages/SalesPersonProfile/SalesPersonProfile'))
const CompanyProfilePage = lazyWithRetry(() => import('@/pages/CompanyProfile/CompanyProfilePage'))
const TransactionSales2 = lazyWithRetry(() => import('@/pages/transactions/sales/sales2/sales2'))
const TransactionPurchase2 = lazyWithRetry(() => import('@/pages/transactions/purchase/purchase2/purchase2'))
const TransactionReceipt2 = lazyWithRetry(() => import('@/pages/transactions/receipt/receipt2/receipt2'))
const TransactionCreditNote2 = lazyWithRetry(() => import('@/pages/transactions/creditNote/creditNote'))
const TransactionDebitNote2 = lazyWithRetry(() => import('@/pages/transactions/debitNote/debitNote'))
const TransactionJournal2 = lazyWithRetry(() => import('@/pages/transactions/journal/journal'))
const TransactionPayment2 = lazyWithRetry(() => import('@/pages/transactions/payment/payment2/payment2'))
const Invoices2 = lazyWithRetry(() => import('@/pages/invoices/invoices2/invoices2'))
const InvoiceDetail2 = lazyWithRetry(() => import('@/pages/invoices/detail/detail2/InvoiceDetail2'))
const MfgSyncStatusPage = lazyWithRetry(() => import('@/pages/syncStatus/MfgSyncStatusPage'))
const Installations = lazyWithRetry(() => import('@/pages/installations/Installations'))
const NotOnboardingLeads = lazyWithRetry(() => import('@/pages/installations/NotOnboardingLeads'))
const Support = lazyWithRetry(() => import('@/pages/support/Support'))
const SupportTicketDetail = lazyWithRetry(() => import('@/pages/support/TicketDetail'))

const B2BMarketplace = lazyWithRetry(() => import('@/pages/B2BMarketplace'));
const BizzSetu = lazyWithRetry(() => import('@/pages/BizzSetu'));
const HomepageV2 = lazyWithRetry(() => import('@/pages/homepage/HomepageV2'));
const TeamHierarchy = lazyWithRetry(() => import('@/pages/TeamHierarchy/TeamHierarchy'));
const EmployeeHierarchy = lazyWithRetry(() => import('@/pages/EmployeeHierarchy/EmployeeHierarchy'));
const BankAndCash = lazyWithRetry(() => import('@/pages/BankAndCash'));
const PartySkuDeepDive = lazyWithRetry(() => import('@/pages/PartySkuDeepDive/PartySkyDive'));
const DumpReport = lazyWithRetry(() => import('@/pages/DumpReport/DumpReport'));
const OpscReport = lazyWithRetry(() => import('@/pages/OpscReport'));
const SelectCompany = lazyWithRetry(() => import('@/pages/company/SelectCompany'));

export const routes = [
  {
    path: '/',
    component: BizzSetu,
    layout: 'none',
    protected: false,
  },
  {
    path: '/homepage',
    component: Homepage,
    layout: 'none',
    protected: false,
  },
  {
    path: '/v2',
    component: HomepageV2,
    layout: 'none',
    protected: false,
  },
  {
    path: '/b2b-marketplace',
    component: B2BMarketplace,
    layout: 'none',
    protected: false,
  },
  {
    path: '/bizz-setu',
    component: BizzSetu,
    layout: 'none',
    protected: false,
  },
  {
    path: '/search',
    component: SearchPage,
    layout: 'none',
    protected: false,
  },
  {
    path: '/contact',
    component: ContactPage,
    layout: 'none',
    protected: false,
  },
  {
    path: '/details/:slug',
    component: DetailPage,
    layout: 'none',
    protected: false,
  },
  {
    path: '/company/:slug',
    component: DetailPage,
    layout: 'none',
    protected: false,
  },
  {
    path: '/product/:companySlug/:productSlug',
    component: ProductPage,
    layout: 'none',
    protected: false,
  },
  {
    path: '/about',
    component: AboutPage,
    layout: 'none',
    protected: false,
  },
  {
    path: '/privacy-policy',
    component: PrivacyPolicy,
    layout: 'none',
    protected: false,
  },
  // Auth pages (no layout)
  {
    path: '/login',
    component: Login,
    layout: 'none',
    protected: false,
  },
  {
    path: '/profile',
    component: Profile,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/my-profile',
    component: MyProfile,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/saved-profiles',
    component: SavedProfile,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/otp',
    component: Otp,
    layout: 'none',
    protected: false,
  },
  {
    path: '/select-company',
    component: SelectCompany,
    layout: 'none',
    protected: false,
  },
  {
    path: '/onboarding/role',
    component: Role,
    layout: 'none',
    protected: false,
  },

  // Protected pages (auth layout)
  {
    path: '/dashboard',
    component: Dashboard,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/tally-dashboard',
    component: TallyDashboard,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/tally-dashboard-v2',
    component: FinancialDashboard,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/mfg-dashboard',
    component: MfgDashboard,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/financial-dashboard',
    component: FinancialDashboard,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/dump-report',
    component: DumpReport,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/opsc-report',
    component: OpscReport,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/opsc',
    component: OpscReport,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/messages',
    component: Messages,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/requirements',
    component: Requirement,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/products',
    component: Products,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/products/add',
    component: AddEditProduct,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/products/edit/:productId',
    component: AddEditProduct,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/requirements',
    component: Requirement,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/products',
    component: Products,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/products/add',
    component: AddEditProduct,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/products/edit/:productId',
    component: AddEditProduct,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/explore',
    component: Explore,
    layout: 'auth',
    protected: true,
  },



  // Transaction routes
  {
    path: '/transactions/sales',
    component: TransactionSales,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/transactions/purchase',
    component: TransactionPurchase,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/transactions/payment',
    component: TransactionPayment,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/transactions/receipt',
    component: TransactionReceipt,
    layout: 'auth',
    protected: true,
  },
  // Secondary Sales routes - V2 (New)
  {
    path: '/secondary-sales/send-request-v2',
    component: SendRequestV2,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/secondary-sales/auto-map-skus',
    component: AutoMapSkus,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/secondary-sales/my-requests-v2',
    component: MyRequestsV2,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/secondary-sales/my-requests-v2/network',
    component: DistributorNetwork,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/secondary-sales/my-requests-v2/:id',
    component: MyRequestDetail2,
    layout: 'auth',
    protected: true,
  },
  // Secondary Sales routes - V1 (Old - still accessible via direct URL)
  {
    path: '/secondary-sales/send-request',
    component: SendRequest,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/secondary-sales/my-requests',
    component: MyRequests,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/secondary-sales/my-requests/:id',
    component: MyRequestDetail,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/secondary-sales/requests',
    component: Requests,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/secondary-sales/requests-v2',
    component: RequestsV2,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/secondary-sales/sku-sales',
    component: SkuSales,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/secondary-sales/sku-sales-v2',
    component: SkuSalesV2,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/secondary-sales/sku-sales-v2/mapping-details/:skuId',
    component: SKUMappingDetails,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/secondary-sales/sku-sales-v2/mapped-distributors',
    component: MappedDistributorsV2,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/secondary-sales/sku-sales/mapped-distributors',
    component: MappedDistributors,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/secondary-sales/sku-sales/mapped-distributors/:manuDistriMappingId/unmapped-skus',
    component: UnmappedSkus,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/secondary-sales/my-requests-v2/:id/hierarchy-mapping',
    component: HierarchyMappingPage,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/secondary-sales/my-requests-v2/:id/map-v2',
    component: RequestMapV2,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/secondary-sales/requests/:id/map-v2',
    component: RequestMapV2,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/secondary-sales/requests/:id/map',
    component: RequestMapV2,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/secondary-sales/requests/:id',
    component: RequestMap,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/secondary-sales/mapping-logs',
    component: MappingLogs,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/secondary-sales/mapping-logs-v2',
    component: MappingLogsV2,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/manufacturers',
    component: Manufacturers,
    layout: 'auth',
    protected: true,
  }, {
    path: '/sales/invoices',
    component: SalesInvoices,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/sales/distributors',
    component: SalesDistributorsV2,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/sales/distributors2',
    component: SalesDistributors,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/sales/distributors-v2',
    component: SalesDistributorsV2,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/sales/outlets',
    component: SalesOutlets,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/sales/outlets2',
    component: SalesOutlets2,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/sales/invoices2',
    component: SalesInvoices2,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/sales/invoices2/detail/:id',
    component: SalesInvoiceDetail2,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/sales/purchase-invoices2',
    component: SalesInvoices2,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/sales/purchase-invoices2/detail/:id',
    component: SalesInvoiceDetail2,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/sales/invoices/:id',
    component: SalesInvoiceDetail,
    layout: 'auth',
    protected: true,
  },

  // Invoice routes
  {
    path: '/invoices',
    component: Invoices,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/invoices/detail/:id',
    component: InvoiceDetail,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/user-role-management',
    component: UserRoleManagement,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/user-role-management/hierarchy',
    component: EmployeeHierarchy,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/team-hierarchy',
    component: TeamHierarchy,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/roles-and-permissions',
    component: RolesAndPermissions,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/roles-and-permissions/create',
    component: CreateRole,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/roles-and-permissions/edit/:roleId',
    component: CreateRole,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/receivable',
    component: Receivable,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/dashboard/receivables-v2',
    component: ReceivablesV2,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/dashboard/receivables-v2/customer-detail',
    component: CustomerDetailPageV2,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/receivable/detail',
    component: ReceivableDetailPage,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/payable',
    component: Payable,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/dashboard/payables-v2',
    component: PayablesV2,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/dashboard/payables-v2/supplier-detail',
    component: SupplierDetailPageV2,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/payable/detail',
    component: PayableDetailPage,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/dashboard/bank-and-cash',
    component: BankAndCash,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/dashboard/party-sku-deep-dive',
    component: PartySkuDeepDive,
    layout: 'auth',
    protected: true,
  },

  // Master Sku
  {
    path: '/skus',
    component: MasterSkus,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/skus-v2',
    component: MasterSkus2,
    layout: 'auth',
    protected: true,
  },
  // setting page
  {
    path: '/tally-sync',
    component: TallySync,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/mfg-sync-status',
    component: MfgSyncStatusPage,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/installations',
    component: Installations,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/not-onboarding-leads',
    component: NotOnboardingLeads,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/support',
    component: Support,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/support/:id',
    component: SupportTicketDetail,
    layout: 'auth',
    protected: true,
  },

  // Labels (both manufacturer and distributor)
  {
    path: '/labels',
    component: Labels,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/labels/:id/members',
    component: TeamMembersPage,
    layout: 'auth',
    protected: true,
  },

  // Industry Categories
  {
    path: '/industry-categories',
    component: IndustryCategories,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/sales-mapping',
    component: SalesMapping,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/distributor-staff-mapping',
    component: DistributorStaffMapping,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/industry-subcategories',
    component: IndustrySubcategories,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/industry-subcategories/:subcategoryId',
    component: SubcategoryDetail,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/sales-profile',
    component: SalesPersonProfile,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/company-profile',
    component: CompanyProfilePage,
    layout: 'auth',
    protected: true,
  },

  {
    path: '/transactions/sales-v2',
    component: TransactionSales2,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/transactions/purchase-v2',
    component: TransactionPurchase2,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/transactions/receipt-v2',
    component: TransactionReceipt2,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/transactions/credit-note-v2',
    component: TransactionCreditNote2,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/transactions/debit-note-v2',
    component: TransactionDebitNote2,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/transactions/generals-v2',
    component: TransactionJournal2,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/transactions/payment-v2',
    component: TransactionPayment2,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/invoices-v2',
    component: Invoices2,
    layout: 'auth',
    protected: true,
  },
  {
    path: '/invoices-v2/detail/:id',
    component: InvoiceDetail2,
    layout: 'auth',
    protected: true,
  },

  // 404 pages
  {
    path: '*',
    component: NotFound,
    layout: 'none',
    protected: false,
  }
];

// Helper to get route by path
export const getRouteByPath = path => {
  return routes.find(route => route.path === path);
};

// Helper to get all protected routes
export const getProtectedRoutes = () => {
  return routes.filter(route => route.protected);
};

// Helper to get all public routes
export const getPublicRoutes = () => {
  return routes.filter(route => !route.protected);
};
